import React from 'react';
import { ScrollView, View, Image } from 'react-native';
import axios from 'axios';
import { TextInput, Text, Button } from 'react-native-paper';
import { MainContext } from '../../contexts/MainContext';
import { useSession } from '../../ctx/ctx';

export default function Profile() { 
  const { signOut } = useSession();
  const myContext = React.useContext(MainContext);
  const userData = myContext.userData;
  const [requestLoading, setRequestLoading] = React.useState(false);

  const logOut = () => {
    setRequestLoading(true);
    axios.all([
      axios.get(`/logout`),
    ])
      .then(axios.spread((data) => {
        if(data.data.success) {
          signOut();
          myContext.activateSnackbar(true, 'خروج با موفقی انجام شد');
          setRequestLoading(false); 
        }
      }))
      .catch((error) => console.error(error));
  }

  return (
    <View style={{ flex: 1, backgroundColor: '#fcfcfd' }}>
      <ScrollView contentContainerStyle={{ backgroundColor: '#fcfcfd', alignItems: 'center', paddingHorizontal: 18, paddingTop: 16 }} >
        <Image style={{ width: 80, height: 80, borderRadius: 60, borderWidth: 1, borderColor: '#BFC0C5', marginTop: 19 }} source={{uri: userData.profile}} />
        <Text style={{ fontSize: 16, color: '#292D32', fontFamily: 'IRANSans_Medium', marginTop: 12, marginBottom: 4 }}>{userData.name}</Text>
        <Text style={{ fontSize: 14, color: '#8D8F94', fontFamily: 'IRANSans_Medium' }}>{userData.mobile}</Text>
        <Button loading={requestLoading} mode="outlined" style={{ marginTop: 16, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5, paddingHorizontal: 16 }} labelStyle={{ fontFamily: 'IRANSans_Medium', fontSize: 16, color: '#D61600' }} onPress={() => logOut()}>خروج از حساب</Button>
        <View style={{ width: '100%', marginTop: 32 }}>
          <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', marginBottom: 24 }}>حساب کاربری</Text>
          <TextInput
            label="نام"
            mode="outlined"
            activeOutlineColor="#c6c5c4"
            style={{ marginBottom: 24, fontSize: 14 }}
            value={userData.name}
            disabled
          />
          <TextInput
            label="شماره موبایل"
            mode="outlined"
            activeOutlineColor="#c6c5c4"
            style={{ marginBottom: 24, fontSize: 14 }}
            value={userData.mobile}
            disabled
          />
          <TextInput
            label="جنسیت"
            mode="outlined"
            activeOutlineColor="#c6c5c4"
            style={{ marginBottom: 24, fontSize: 14 }}
            value={userData.sex === 'male' ? 'مرد' : 'زن'}
            disabled
          />
        </View>
      </ScrollView>
    </View>
  );
}

